import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DynamicReportGeneralDetailComponent } from './dynamic-report-general-detail.component';
import { DynamicReportGeneralResolver } from '../dynamic-report-general.resolver';

const routes: Routes = [
    {
        path: '',
        component: DynamicReportGeneralDetailComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [DynamicReportGeneralResolver],
})
export class DynamicReportGeneralDetailRoutingModule { } 